import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill'

export default async function polyfill (): Promise<void> {
  if (typeof shouldPolyfill() !== 'undefined' && shouldPolyfill() !== null) {
    // Load the polyfill 1st BEFORE loading data
    await import('@formatjs/intl-relativetimeformat/polyfill')
  }

  if ((Intl.RelativeTimeFormat as any).polyfilled !== null) {
    await import('@formatjs/intl-relativetimeformat/locale-data/es')
    await import('@formatjs/intl-relativetimeformat/locale-data/en')
  }
}
